import { createContext, useContext, type ReactNode } from "react";

// When the formula editor is opened from inside another full-screen dialog
// (e.g. the template-correction editor), it should render smaller so the parent
// dialog stays visible behind it rather than being fully covered.
const NestedFormulaContext = createContext(false);

export function NestedFormulaProvider({ children }: { children: ReactNode }) {
  return (
    <NestedFormulaContext.Provider value={true}>
      {children}
    </NestedFormulaContext.Provider>
  );
}

export function useNestedFormula(): boolean {
  return useContext(NestedFormulaContext);
}
